"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnPePen = exports.EnPeUsd = exports.EsPePen = exports.EsPeUsd = void 0;
class EsPeUsd {
    constructor() {
        this.locale = "es-pe";
        this.dateFormat = {
            short: "d/MM/yyyy",
            medium: "dd de MMMM de yyyy",
            long: "dddd, d de MMMM de yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "US$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EsPeUsd = EsPeUsd;
class EsPePen {
    constructor() {
        this.locale = "es-pe";
        this.dateFormat = {
            short: "d/MM/yyyy",
            medium: "dd de MMMM de yyyy",
            long: "dddd, d de MMMM de yyyy",
        };
        this.currencyFormat = {
            code: "PEN",
            symbol: "S/",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "Cn",
            negativePattern: "-Cn"
        };
    }
}
exports.EsPePen = EsPePen;
class EnPeUsd {
    constructor() {
        this.locale = "en-pe";
        this.dateFormat = {
            short: "M/d/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, MMMM dd, yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "US$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnPeUsd = EnPeUsd;
class EnPePen {
    constructor() {
        this.locale = "en-pe";
        this.dateFormat = {
            short: "M/d/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, MMMM dd, yyyy",
        };
        this.currencyFormat = {
            code: "PEN",
            symbol: "$",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "Cn",
            negativePattern: "(Cn)"
        };
    }
}
exports.EnPePen = EnPePen;
